import { ISubmitPaymentConsent, ISuccessResponseType } from "../../constants/commonTypes";
import * as transactionActions from "../actionTypes/transactionActionTypes"
import { decrypt, getTransactionIdFromURL } from "../../constants/utils";
export interface IAccountType {
  isActive: boolean;
  maskedAcc: string;
  isValidVintage: boolean
}
export interface TransactionState {
  userName: string;
  userDOB: string;
  pan: string;
  emailId: string;
  amount: number;
  currency: string;
  referenceNumber: string;
  purposeCode: string;
  limit: number;
  freezeFlag: boolean;
  partnerName: string;
  accNumbers: Array<IAccountType>;
  transactionDetailsFetched: boolean;
  consentResponse: ISuccessResponseType;
  submitRequest: ISubmitPaymentConsent;
  fileContent: string;
  version: string;
  uploadFileContent: string;
  uploadFileVersion: string;
  activeAccount:any;
  demog_error: any;
  lastLoginTime: string;
}

export const initialState: TransactionState = {
  userName: "",
  userDOB: "",
  pan: "",
  emailId: "",
  amount: 0,
  freezeFlag: false,
  currency: "",
  referenceNumber: "",
  purposeCode: "",
  limit: 0,
  partnerName: "",
  accNumbers: [],
  transactionDetailsFetched: false,
  lastLoginTime: "",
  consentResponse: {
    status: "",
    code: 0,
    data: null
  },
  submitRequest: {
    funds: {
      source: "",
      desc: ""
    },
    finalAccNo: "",
    finalRemittanceAmt: 0,
    taxDeclarationVersion: "",
    userName:'',
  },
  fileContent: "",
  version: "",
  activeAccount: "",
  uploadFileContent: "",
  uploadFileVersion: "",
  demog_error: false
}

export const TransactionDetailsReducer = (
  state: TransactionState = initialState,
  action: transactionActions.TransactionAction
): TransactionState => {
  switch (action.type) {
    case transactionActions.GET_TRANSACTION_DETAILS_SUCCESS:
      return {
        ...state,
        userName: action.userName? decrypt(action.userName, getTransactionIdFromURL()) : '',
        userDOB: action.userDOB? decrypt(action.userDOB, getTransactionIdFromURL()): '',
        pan: action.pan,
        freezeFlag: action.freezeFlag,
        emailId: action.emailId,
        amount: action.amount,
        currency: action.currency,
        referenceNumber: action.referenceNumber,
        purposeCode: action.purposeCode,
        limit: action.limit,
        partnerName: action.partnerName,
        accNumbers: action.accNumbers,
        lastLoginTime: action.lastLoginTime,
        transactionDetailsFetched: true
      };
    case transactionActions.SUBMIT_TRANSACTION_CONSENT_SUCCESS:
      return {
        ...state,
        consentResponse: action.consentResponse
      }
      case transactionActions.GET_TRANSACTION_DETAILS_FAILURE:
      return {
        ...state,
        demog_error: true
      }
      case transactionActions.SUBMIT_TRANSACTION_CONSENT_FAILURE:
      return {
        ...state,
        demog_error: true
      }
    case transactionActions.SUBMIT_TRANSACTION_CONSENT_RESET:
      return {
        ...state,
        consentResponse: {
          status: "",
          code: 0,
          data: null
        }
      }
    case transactionActions.SUBMIT_TRANSACTION_CONSENT:
      return {
        ...state,
        submitRequest: action.request
      }
    case transactionActions.GET_TAX_DETAILS_SUCCESS:
      return {
        ...state,
        fileContent: action.response.fileContent,
        version: action.response.version
      }
      case transactionActions.GET_UPDATE_SUCCESS:
      return {
        ...state,
        uploadFileContent: action.response.fileContent,
        uploadFileVersion: action.response.version
      }
    default:
      return state
  }
}


